"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BackgroundPanel = _interopRequireDefault(require("./BackgroundPanel"));

var _SizePanel = _interopRequireDefault(require("./SizePanel"));

var _RemovePanel = _interopRequireDefault(require("./RemovePanel"));

var _ColorPanel = _interopRequireDefault(require("./ColorPanel"));

var _OrderPanel = _interopRequireDefault(require("./OrderPanel"));

var _TextPanel = _interopRequireDefault(require("./TextPanel"));

var _ImagePanel = _interopRequireDefault(require("./ImagePanel"));

var _OverlayPanel = _interopRequireDefault(require("./OverlayPanel"));

var _LinkPanel = _interopRequireDefault(require("./LinkPanel"));

var _AnchorsPanel = _interopRequireDefault(require("./AnchorsPanel"));

var _AnchorPanel = _interopRequireDefault(require("./AnchorPanel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PANELS = {
  text: [_SizePanel.default, _TextPanel.default, _ColorPanel.default, _OverlayPanel.default, _OrderPanel.default, _RemovePanel.default],
  rect: [_SizePanel.default, _ColorPanel.default, _OverlayPanel.default, _OrderPanel.default, _RemovePanel.default],
  circle: [_SizePanel.default, _ColorPanel.default, _OverlayPanel.default, _OrderPanel.default, _RemovePanel.default],
  curve: [_SizePanel.default, _ColorPanel.default, _AnchorsPanel.default, _AnchorPanel.default, _OverlayPanel.default, _OrderPanel.default, _RemovePanel.default],
  image: [_SizePanel.default, _ImagePanel.default, _OverlayPanel.default, _OrderPanel.default, _RemovePanel.default],
  qr: [_SizePanel.default, _ColorPanel.default, _LinkPanel.default, _OrderPanel.default, _RemovePanel.default]
};

var SettingsPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(SettingsPanel, _Component);

  function SettingsPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SettingsPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SettingsPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getPanels = function () {
      var type = _this.props.type;
      return PANELS[type] || [_BackgroundPanel.default];
    };

    return _this;
  }

  _createClass(SettingsPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          postFileUrl = _this$props.postFileUrl;
      return _react.default.createElement("div", null, this.getPanels().map(function (Panel, index) {
        return _react.default.createElement(Panel, {
          key: "panel-".concat(index),
          type: type,
          postFileUrl: postFileUrl
        });
      }));
    }
  }]);

  return SettingsPanel;
}(_react.Component);

exports.default = SettingsPanel;
SettingsPanel.propTypes = {
  type: _propTypes.default.string,
  postFileUrl: _propTypes.default.string
};